import React from "react";
import GitHubCalendar from "react-github-calendar";
import { Container } from "react-bootstrap";

function Github() {
  const theme = {
    light: [
      '#EAF4FD',
      '#D9EAFD',
      '#C4E1F6',
      '#9CC4E2',
      '#4B95CC',
    ],
  };

  return (
    <Container>
      <div className="project-header">
        <h1>Days I Code</h1>
      </div>
      <div className="calendar-container">
        <GitHubCalendar
          username="YaoyiW27"
          blockSize={15}
          blockMargin={5}
          fontSize={16}
          theme={theme}
          colorScheme="light"
        />
      </div>
    </Container>
  );
}

export default Github;